module.exports = __webpack_public_path__ + "static/IBE-967f2aefeda9306b16d0d99d42140c90.svg";